import { Component, Input, OnInit } from '@angular/core';
import { WhiskeyItem } from '../../../menu.model'

@Component({
  selector: 'whiskey-list',
  templateUrl: './whiskey-list.component.html',
  styleUrls: ['./whiskey-list.component.scss']
})
export class WhiskeyListComponent {
  constructor() { }

  @Input() whiskeyList: Array<WhiskeyItem> = [];

  note: number | undefined;

  tastingNote(index: number) {
    this.note = index;
  }

  closeNote() {
    this.note = undefined;
  }

}
